export default "__VITE_ASSET__nlK0Wy9e__"